// src/main.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";

// ✅ IMPORTANT: import default router to avoid named-export mismatch
import router from "@/pages/AppRoutes";

// Global styles (base → brand → theme → utilities)
import "@/styles/index.css";
import "@/styles/brand.css";
import "@/styles/theme.css";
import "@/theme/aura.css";
import "@/styles/synktribe.layer.css";
import "./styles/activa.css";
import "./index.css";
import "./styles/glass.css";

// App-wide providers
import { DiagnosticsProvider } from "@/context/DiagnosticsContext";
import { IntentThemeProvider } from "@/theme/intentTheme";
import { DeviceStoreProvider } from "@/devices/store";
import { AuthSessionProvider } from "@/features/auth";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

ReactDOM.createRoot(rootEl).render(
  <DiagnosticsProvider>
    <IntentThemeProvider initial="productivity">
      <DeviceStoreProvider>
        <AuthSessionProvider>
          <RouterProvider router={router} />
        </AuthSessionProvider>
      </DeviceStoreProvider>
    </IntentThemeProvider>
  </DiagnosticsProvider>,
);
